import React from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useJobContext } from "../../context/JobContext";
import { GoogleLogin } from "@react-oauth/google";

const Login = () => {
    const { login } = useJobContext();
    const navigate = useNavigate();

    const handleSuccess = async (credentialResponse: any) => {
        if (credentialResponse.credential) {
            const success = await login(credentialResponse.credential);
            if (success) {
                navigate("/cms");
            }
        }
    };

    const handleError = () => {
        console.log("Login Failed");
        alert("Google Login Failed");
    };

    return (
        <div className="page-content d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
            <Container style={{ maxWidth: "400px" }}>
                <div className="text-center mb-4">
                    <h3>CMS Login</h3>
                    <p className="text-muted">Please sign in with your @geargames.com account</p>
                </div>

                <div className="d-flex justify-content-center">
                    <GoogleLogin
                        onSuccess={handleSuccess}
                        onError={handleError}
                        useOneTap
                    />
                </div>
            </Container>
        </div>
    );
};

export default Login;
